import { useAtomValue } from 'jotai'
import React from 'react'

import { brandGroupIdAtom } from '~/atoms'

import { useSurveyQueryData } from './useSurveyQueryData'

export const useSurveyQueryActiveBrandGroup = () => {
  const survey = useSurveyQueryData()

  const brandGroupId = useAtomValue(brandGroupIdAtom)

  return React.useMemo(
    () =>
      survey?.brandGroups.find(
        (brandGroup) => brandGroup.id === brandGroupId,
      ) ?? null,
    [brandGroupId, survey],
  )
}
